import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { apiQueryQuoteDeclarations } from '../../api/quoteApi';
import { PROVIDER_SOURCE } from '../../constants/quote';
import { GIT_DECLARATION_ID, GREAT_AMERICAN_DECLARATION_P1, RECRUITMENT_DECLARATION } from '../../localeConstants';
export var getInsurerAllDeclarationQuestionIdList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(quoteId, config) {
    var list, _yield$apiQueryQuoteD, _yield$apiQueryQuoteD2, res;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            list = [];

            if (![PROVIDER_SOURCE().ACCELERANT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
              _context.next = 11;
              break;
            }

            list.push('accelerant_generic_declaration');
            _context.next = 5;
            return apiQueryQuoteDeclarations({
              quoteId: quoteId
            });

          case 5:
            _yield$apiQueryQuoteD = _context.sent;
            _yield$apiQueryQuoteD2 = _slicedToArray(_yield$apiQueryQuoteD, 1);
            res = _yield$apiQueryQuoteD2[0];

            if (res) {
              list.push(res.question_id);
            }

            _context.next = 12;
            break;

          case 11:
            if ([PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
              list.push(GIT_DECLARATION_ID);
            } else if ([PROVIDER_SOURCE().RECRUITMENT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
              list.push(RECRUITMENT_DECLARATION);
            } else if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
              list.push(GREAT_AMERICAN_DECLARATION_P1);
            }

          case 12:
            return _context.abrupt("return", list);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInsurerAllDeclarationQuestionIdList(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();